import AirDatepicker from "air-datepicker";
import localeRu from "air-datepicker/locale/ru";
import localeEn from "air-datepicker/locale/en";

export class Calendar {
    datepicker

    constructor(el, onRenderCell, onSelect) {
        this.el = el;
        this.onRenderCell = onRenderCell;
        this.onSelect = onSelect;
        this.minDate = this.el.getAttribute("data-min-date");
        this.maxDate = this.el.getAttribute("data-max-date");
        this.locale = this.el.getAttribute("data-locale");

        this.datepicker = new AirDatepicker(this.el, {
            inline: false,
            position: "bottom right",
            locale: this.locale === "ru" ? localeRu : localeEn,
            dateFormat: "yyyy-MM-dd",
            multipleDates: false,
            autoClose: true,
            showEvent: "click",
            prevHtml: 
            `<svg width="20" height="20">
                <use href="#calendar-arrow-prev"></use>
            </svg>`,
            nextHtml: 
            `<svg width="20" height="20">
                <use href="#calendar-arrow-next"></use>
            </svg>`,
            minDate: this.minDate,
            maxDate: this.maxDate,
            visible: false,

            onRenderCell: ({date, cellType, datepicker}) => {
                return this.onRenderCell(date, cellType, datepicker);
            },

            onSelect: ({date, formattedDate, datepicker}) => {
                this.onSelect(date, formattedDate, datepicker);
            },

            onHide: (isFinished) => {
                if (isFinished) {
                    this.datepicker.clear({silent: true});    
                    setTimeout(() => {
                        this.datepicker.$el.value = "Календарь";        
                    }, 0);
                }
            }
        })  
    }
}